export default __webpack_public_path__ + "static/media/CapaInsertDriveFile.25644947.svg";